import React, { useState } from "react";
import { Truck, Download, RefreshCw } from "lucide-react";
import { axios, API } from "../lib/api";

const renderLabelAction = ({ state, order, download, downloading, generate, busy }) => {
  if (state.royalMailId) {
    return (
      <button onClick={download} disabled={downloading}
        className="brutalist-btn-secondary text-xs py-1 px-3 flex items-center gap-1"
        data-testid={`label-download-${order.id}`}>
        <Download className="w-3 h-3" />{downloading ? "…" : "Download Label"}
      </button>
    );
  }
  if (state.fulfillment !== "manual_non_uk") {
    return (
      <button onClick={generate} disabled={busy}
        className="brutalist-btn-primary text-xs py-1 px-3 flex items-center gap-1"
        data-testid={`label-generate-${order.id}`}>
        <RefreshCw className={`w-3 h-3 ${busy ? "animate-spin" : ""}`} />{busy ? "…" : "Generate Label"}
      </button>
    );
  }
  return null;
};


export const ShippingLabelControls = ({ order, token }) => {
  const [state, setState] = useState({
    fulfillment: order.fulfillment,
    royalMailId: order.royal_mail_order_id,
    tracking: order.tracking_number,
    error: order.royal_mail_error,
  });
  const [busy, setBusy] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const generate = async () => {
    setBusy(true);
    try {
      const r = await axios.post(
        `${API}/orders/${order.id}/shipping-label`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setState({
        fulfillment: r.data.fulfillment,
        royalMailId: r.data.royal_mail_order_id,
        tracking: r.data.tracking_number,
        error: r.data.error,
      });
    } catch (e) {
      setState((s) => ({ ...s, error: e.response?.data?.detail || "Label creation failed" }));
    } finally { setBusy(false); }
  };

  const download = async () => {
    setDownloading(true);
    try {
      const res = await axios.get(`${API}/orders/${order.id}/label`, {
        headers: { Authorization: `Bearer ${token}` }, responseType: "blob"
      });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = `label-${order.id.slice(0,8)}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setState((s) => ({ ...s, error: e.response?.data?.detail || "Could not download label" }));
    } finally { setDownloading(false); }
  };

  return (
    <div className="mt-3 pt-3 border-t-2 border-dashed border-gray-200" data-testid={`label-controls-${order.id}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex items-center gap-2 text-xs">
          <Truck className="w-4 h-4 text-[#FF6B6B]" />
          <span className="font-bold uppercase">Royal Mail</span>
          {state.tracking && (
            <span className="bg-green-100 text-green-800 px-2 py-0.5 rounded-full font-mono">
              {state.tracking}
            </span>
          )}
          {state.fulfillment === "manual_non_uk" && <span className="text-gray-500">Non-UK — manual fulfillment</span>}
          {state.fulfillment === "label_failed" && <span className="text-red-600">Label failed</span>}
        </div>
        <div className="flex gap-2">
          {renderLabelAction({ state, order, download, downloading, generate, busy })}
        </div>
      </div>
      {state.error && (
        <p className="text-[11px] text-red-600 mt-2" data-testid={`label-error-${order.id}`}>
          {state.error}
        </p>
      )}
    </div>
  );
};
